<template>
  <canvas v-show="ready" id="myChart" ref="myChart" width="400" height="400"></canvas>
</template>

<script>
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { getStyle } from "@coreui/coreui-pro/dist/js/coreui-utilities";

const brandPrimary = getStyle("--primary");
const brandSecondary = getStyle("--secondary");
const brandSuccess = getStyle("--success");
const brandWarning = getStyle("--warning");
const brandDanger = getStyle("--danger");
const brandInfo = getStyle("--info");

export default {
  props: ["client_customer", "from_date", "to_date", "product", "process_type"],
  data() {
    return {
      ready: false,
      labels: [],
      data: [
        {
          label: "Kg Exp",
          data: [],
          backgroundColor: brandPrimary,
          borderColor: brandPrimary,
          borderWidth: 1,
          datalabels: {
            formatter: function (value, context) {
              return new Intl.NumberFormat("es-CL").format(parseInt(value)) + " Kg";
            }
          }
        },
        {
          label: "Kg Desc",
          data: [],
          backgroundColor: brandSecondary,
          borderColor: brandSecondary,
          borderWidth: 1,
          datalabels: {
            color: "#73818f",
            formatter: function (value, context) {
              return new Intl.NumberFormat("es-CL").format(parseInt(value)) + " Kg";
            }
          }
        }
      ]
    };
  },
  async mounted() {
    const self = this;
    try {
      const response = await this.$axios({
        method: "GET",
        url: `production/dashboard/process/top_ten_growers?client_customer=${this.client_customer}&product=${this.product}&process_type=${this.process_type}&from_date=${this.from_date}&to_date=${this.to_date}`,
        headers: {
          "Content-Type": "application/json"
        }
      });
      this.loading = false;
      this.labels = response.data.labels;
      this.data[0].data = response.data.dataset_2;
      this.data[1].data = response.data.dataset.map((net, index) => net - response.data.dataset_2[index]);
      this.ready = true;
    } catch (error) {
      console.log(error);
      this.loading = false;
    }
    let ctx = this.$refs.myChart.getContext("2d");
    const myChart = new Chart(ctx, {
      type: "bar",
      data: {
        labels: this.labels,
        datasets: this.data
      },
      plugins: [ChartDataLabels],
      options: {
        maintainAspectRatio: false,
        indexAxis: "y",
        plugins: {
          legend: {
            display: false,
            position: "right"
          },
          datalabels: {
            color: "#ffffff"
          },
          title: {
            display: true,
            text: "Top 10 productores"
          }
        },
        scales: {
          x: {
            stacked: true
          },
          y: {
            stacked: true
          }
        },
        animation: {
          onComplete: function (animation) {
            setTimeout(() => {
              self.$emit("chart-ready");
            }, 500);
          }
        }
      }
    });
  }
};
</script>

<style></style>
